import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TabsWrapper = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.space(10)};

  ${mediaMin.mediumBreakpoint`
    margin-bottom: ${props => props.theme.space(5)};
  `}
`;
